import React from 'react';
import { Row } from '@fiverr-private/briefs_table';
import { Stack } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import { BriefDisplayStatus } from '@fiverr-private/dynamic_matching';
import { appTranslate } from '../../../../i18n';
import { BriefItem } from '../../../../../lib/types/brief';

interface SummaryProps {
  row: Row<BriefItem>;
}

const HIDE_OFFERS_COUNT_STATUS = [BriefDisplayStatus.HIRED];

export const Summary: React.FC<SummaryProps> = ({ row }: SummaryProps) => {
  if (row.original.briefDisplayStatus === BriefDisplayStatus.REJECTED) {
    return null;
  }

  if (row.original.type === 'agentic') {
    const { proposalsCount } = row.original;
    const proposals_count_key =
      proposalsCount === 1 ? 'table.proposals_total_singular' : 'table.proposals_total_plural';

    return (
      <Stack direction="column" alignItems="flexStart" gap="0.5">
        <Text fontWeight="bold" size="b_sm">
          {proposalsCount
            ? appTranslate(proposals_count_key, { params: { total: proposalsCount } })
            : appTranslate('table.no_proposals_yet')}
        </Text>
      </Stack>
    );
  }

  const offers_count_key = row.original.offersCount === 1 ? 'table.offers_total_singular' : 'table.offers_total_plural';
  return (
    <Stack direction="column" alignItems="flexStart" gap="0.5">
      <Text fontWeight="bold" size="b_sm">
        {row.original.hiredCount > 0
          ? appTranslate('table.hired', { params: { total: row.original.hiredCount } })
          : appTranslate('table.no_hires_yet')}
      </Text>
      {!HIDE_OFFERS_COUNT_STATUS.includes(row.original.briefDisplayStatus) && (
        <Text size="b_sm">
          (
          {row.original.offersCount
            ? appTranslate(offers_count_key, { params: { total: row.original.offersCount } })
            : appTranslate('table.no_available_offers')}
          )
        </Text>
      )}
    </Stack>
  );
};
